import {observable, computed, action, toJS} from 'mobx';
import {endpoints, types} from 'main/tools';
import {DomainStore} from 'shared/store';
import ReviewCycleViewModel from 'main/containers/employees/hire/components/steps/reviews/reviews_list/ReviewCycleViewModel';
import _ from 'lodash';
import {PerformanceReviewReviewee} from 'main/stores/performance_reviews';
import {Employee} from 'main/stores/employees';

class ReviewsListState {
  store = new DomainStore();
  employee;
  cycles;
  onChange;

  @observable viewModels = [];

  receiveProps({employee, reviewCycles, onChange}) {
    this.employee = employee;
    this.reviewCycles = reviewCycles;
    this.onChange = onChange;
  }

  @action async load() {
    await this.store._compose([
      endpoints.PERFORMANCE_REVIEWS.REVIEWEES.FOR_EMPLOYEE.with(this.employee.id),
      endpoints.EMPLOYEES.ALL
    ]);

    this.employees = this.store._getAll(
      types.EMPLOYEE,
      Employee
    );

    const reviewees = this.store._getAll(
      types.PERFORMANCE_REVIEWS.REVIEWEE,
      PerformanceReviewReviewee
    );

    this.viewModels = _.map(
      this.reviewCycles,
      cycle => {
        const reviewee = _.find(reviewees, {cycle: {id: cycle.id}});

        return new ReviewCycleViewModel({
          data: {
            ...cycle,
            reviewManagerEmployees: toJS(reviewee?.reviewManagerEmployees) ?? []
          },
          selected: !!reviewee
        })
      } 
    );
  }

  emitOnChange() {
    if (this.onChange) {
      this.onChange(this.selectedReviewCycles);
    }
  }

  @action toggleCycle(cycleViewModel) {
    cycleViewModel.toggle();
    if (cycleViewModel.selected) {
      cycleViewModel.data.reviewManagerEmployees = [
        _.find(this.availableManagers, {id: this.employee.managerId})
      ];
    } else {
      cycleViewModel.data.reviewManagerEmployees = [];
    }
    this.emitOnChange();
  }

  @action updateCycle(cycle, managerId) {
    cycle.reviewManagerEmployees = [
      _.find(this.availableManagers, {id: managerId})
    ];
    this.emitOnChange();
  }

  @action addManager(cycle, manager) {
    cycle.reviewManagerEmployees.push(manager);
    this.emitOnChange();
  }

  @action removeManager(cycle, manager) {
    _.remove(cycle.reviewManagerEmployees, {id: manager.id});
    this.emitOnChange();
  }

  @computed get selectedReviewCycles() {
    return this.viewModels.filter(p => p.selected).map(v => v.data);
  }

  @computed get availableManagers() {
    return _.reject(this.employees, {
      id: this.employee.id
    });
  }
}

export default ReviewsListState;
